import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ChannelUpdateFragmentDoc } from '../../fragments/generated/ChannelUpdate';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChannelsSubscriptionVariables = Types.Exact<{
  data: Types.ChannelSubscriptionInput;
}>;


export type ChannelsSubscription = { channels: { operation: Types.ChannelSubscriptionOperationEnum, channel: { id: string, name: string } } };


export const ChannelsDocument = /*#__PURE__*/ gql`
    subscription Channels($data: ChannelSubscriptionInput!) {
  channels(data: $data) {
    operation
    channel {
      ...ChannelUpdate
    }
  }
}
    ${ChannelUpdateFragmentDoc}`;

export function useChannelsSubscription<TData = ChannelsSubscription>(options: Omit<Urql.UseSubscriptionArgs<ChannelsSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<ChannelsSubscription, TData>) {
  return Urql.useSubscription<ChannelsSubscription, TData, ChannelsSubscriptionVariables>({ query: ChannelsDocument, ...options }, handler);
};